import * as React from 'react';
import { Container, TituloSecao } from './styles';
import Grid from '../../componentes/Grid';
import { useParams } from 'react-router-dom';
import { useContext } from 'react';
import userContext from '../../Context/UserContext';
import { FormatarUrlName } from '../../helpers/valores';

const Autor: React.FC = () => {
  const { id, name }: any = useParams();
  const currentlyUser = useContext(userContext);
  const { Codcliente, Codempresa } = currentlyUser.user;
  const nomeFormatado = FormatarUrlName(decodeURIComponent(name));


  return (
    <Container>
      <TituloSecao>
        Autor {id} - {nomeFormatado}
      </TituloSecao>
      <Grid Titulo={'Autor' + nomeFormatado} Autor={id} Codcliente={Codcliente} Codempresacli={Codempresa} />
    </Container>
  )
};

export default Autor;
